'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.myscripts.show', [])
  .controller('MyScriptsShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/myscripts/show/index.js